import { ACTIONS } from "../../common/constants";

const statementDataReducer = function (state = false, action) {
    switch (action.type) {
        case ACTIONS.SET_STATEMENT_DATA:
            return action.data;
        default:
            return state;
    }
};

export default statementDataReducer;
